/*
 * PC/SPでイメージを切り替える
 */
export default class ReplaceImg {
  constructor() {
    this.setAppInfo()
    this.options = {
      userAgent: false,
      displayWidth: true,
      displayWidthSP: 768
    }

    this.changeDeviceInfo();
    this.set();
    window.addEventListener('resize', () => {
      this.changeDeviceInfo();
      this.set();
    });
  }

  changeDeviceInfo() {
    this.APP.ww = window.innerWidth;
    if(this.options.userAgent && this.options.displayWidth) {
      if (!this.APP.sp && this.options.displayWidthSP < this.APP.ww) {
        this.device = "pc";
      } else {
        this.device = "sp";
      }
    } else if (this.options.userAgent) {
      if (!this.APP.sp) {
        this.device = "pc";
      } else {
        this.device = "sp";
      }
    } else if (this.options.displayWidth) {
      if (this.options.displayWidthSP < this.APP.ww) {
        this.device = "pc";
      } else {
        this.device = "sp";
      }
    }
  }

  setAppInfo() {
    this.APP = {}
    let ua = navigator.userAgent;
    this.APP.sp = ua.indexOf('iPhone') > -1 || ua.indexOf('iPod') > -1 || ua.indexOf('Android') > -1
  }

  replace(src) {
    src = src.replace('device', this.device)
    return src
  }

  set() {
    let _this = this;
    let elms = document.querySelectorAll('[data-src]');
    for(let i = 0; i < elms.length; i++) {
      let elm = elms[i];
      let src = elm.getAttribute('data-src');
      let aaa = _this.replace(src);
      elm.setAttribute('src', aaa);
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/components/ReplaceImg.js